var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9149 16.2422C24.9149 13.264 23.2064 10.606 20.6475 9.31311C20.568 15.0234 15.9384 19.6531 10.228 19.7325C11.5209 22.2914 14.1789 24 17.1571 24C18.5535 24 19.9114 23.6281 21.1045 22.9215L24.881 23.9661L23.8364 20.1896C24.543 18.9965 24.9149 17.6385 24.9149 16.2422V16.2422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2432 9.16406C19.2432 4.1109 15.1323 0 10.0791 0C5.02594 0 0.915039 4.1109 0.915039 9.16406C0.915039 10.8109 1.35339 12.4144 2.18579 13.8221L0.94873 18.2943L5.42108 17.0574C6.8288 17.8898 8.43225 18.3281 10.0791 18.3281C15.1323 18.3281 19.2432 14.2172 19.2432 9.16406ZM8.67285 7.03125H7.2666C7.2666 5.48035 8.5282 4.21875 10.0791 4.21875C11.63 4.21875 12.8916 5.48035 12.8916 7.03125C12.8916 7.81842 12.5583 8.57501 11.977 9.10675L10.7822 10.2003V11.2969H9.37598V9.58099L11.0276 8.06927C11.3228 7.79919 11.4854 7.4306 11.4854 7.03125C11.4854 6.2558 10.8546 5.625 10.0791 5.625C9.30365 5.625 8.67285 6.2558 8.67285 7.03125ZM9.37598 12.7031H10.7822V14.1094H9.37598V12.7031Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIconSelected);
export default __webpack_public_path__ + "static/media/faq-icon-selected.772105ca7e5bf6b75d9df1d960284791.svg";
export { ForwardRef as ReactComponent };